GatorSurvey.app.directive("gsTimeQuestion", ['surveyResponseService', GsTimeQuestion]);
function GsTimeQuestion(surveyResponseService) {
    return {
        restrict: 'AE',
        scope: {
            gsModel: "=ngModel",
            mode: "=?"
        },
        templateUrl: 'Assets/Scripts/App/Directives/Questions/Templates/TimeQuestionLive.html',
        controller: ['$scope', function ($scope) {
           $scope.updateResponseText = function (text) {
                surveyResponseService.updateResponseQuestion($scope.gsModel, text);
            };
          
               surveyResponseService.AddNewQuestion($scope.gsModel,
                   function(response) {
                       $scope.gsModel.input = new Date(response.answer);
                   });
           
        }]
    };
}